<template>
  <div v-if="ShowTableView">
    <chart-table
      :headers="TableSettings ? TableSettings.headers : []"
      :rows="TableSettings ? TableSettings.rows : []"
      :Elements="TableSettings ? TableSettings.Elements : []"
    ></chart-table>
  </div>
  <div v-else ref="root" :class="$style['adl-chart-area']">
    <adl-chart-area
      :data="chartData"
      :rangeX="chartProperties.rangeX"
      :rangeY="chartProperties.rangeY"
      :domainX="chartProperties.domainX"
      :yAxisLabel="chartProperties.yAxisLabel"
      :domainY="chartProperties.domainY"
      :tickQuantityY="chartProperties.tickQuantityY"
      :height="chartProperties.height"
      :currencyFormat="chartProperties.currencyFormat"
      :axisLeftWidth="chartProperties.axisLeftWidth"
      :axisRightWidth="chartProperties.axisRightWidth"
      :legendItems="chartProperties.areaLegendItems"
      :legendKey="chartProperties.areaLegendKey"
      :isHideFirstTick="chartProperties.isHideFirstTick"
      :lineChartColor="chartProperties.lineChartColor"
      @setTooltipData="setTooltipData"
    >
      <template v-slot:tooltipText>
        <mce-hover-flag
          v-if="mouse && mouseDataLine"
          :x="mouse.pageX"
          :y="mouse.pageY"
        >
          <div ref="hover">
            <mce-legend hide-top-border hide-bottom-border>
              <mce-legend-group>
                <strong
                  :class="data.class"
                  v-for="data in mouseDataLine.value.title"
                  :key="data"
                >
                  {{ data.value }}
                </strong>

                <li
                  :class="$style['add-margin']"
                  v-for="(d, i) in mouseDataLine.value.tooltipText"
                  :key="i"
                >
                  <div>{{ d.id }}</div>
                  <div :class="$style['bold-text']" v-if="d.isCurrencyType">
                    {{ d.value }}
                  </div>
                  <div :class="$style['bold-text']" v-else>{{ d.value }}</div>
                </li>
              </mce-legend-group>
            </mce-legend>
          </div>
        </mce-hover-flag>
      </template>
    </adl-chart-area>
  </div>
</template>
<script>
import AdlChartArea from "../custom/chart-area/ChartArea.vue";
import { MceLegend, MceLegendGroup } from "@mce/legend";
import MceHoverFlag from "@mce/hover-flag";
import { ChartToolTip } from "../../mixin";
import ChartTable from "./ChartTable.vue";
export default {
  mixins: [ChartToolTip],
  props: {
    chartProperties: {
      type: Object,
    },

    chartData: {
      type: Array,
    },
    TableSettings: {
      type: Object,
    },
    ShowTableView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mouse: null,
      mouseDataLine: null,
      padding: 20,
    };
  },
  mounted() {},
  computed: {},
  components: {
    AdlChartArea,
    MceLegend,
    MceLegendGroup,
    MceHoverFlag,
    ChartTable,
  },
  methods: {
    async setTooltipData(mouseDataLine, mouse) {
      this.mouseDataLine = mouseDataLine;
      this.mouse = mouse;
      if (this.mouse && this.mouse.pageY) {
        await this.resetToolTipHeight(this.padding);
      }
    },
  },
};
</script>
<style lang="scss" module>
.adl-chart-area {
  .hide-cursor {
    cursor: none !important;
  }
  .add-margin {
    margin-top: 10px;
  }
  .bold-text {
    font-weight: bold;
  }
}
</style>
